import { Link, navigate } from "gatsby";
import { useContext, useState } from "react";
import { GlobalContext } from "../../../../../context/GlobalContext";
import { Tabs } from "../../../../../interfaces/GlobalContext.interface";
import useChangeTheme from "../../../../../shared/hooks/useChangeTheme";
import BurgerMenu from "../../../../atoms/burger-menu/BurgerMenu";
import FontSizeSettings from "../../../../atoms/font-size-settings/FontSizeSettings";
import SearchBarHeader from "../../../../atoms/search-bar-header/SearchBarHeader";
import "./MainHeader.scss";

// @ts-ignore
import moonWhite from "../../../../../assets/icons/CDA/moon_white.svg";
// @ts-ignore
import moonBlack from "../../../../../assets/icons/CDA/moon_black.svg";
// @ts-ignore
import accesibilityIcon from "../../../../../assets/icons/CDA/accesibility.svg";
// @ts-ignore
import accesibilityWhiteIcon from "../../../../../assets/icons/CDA/accesibility_white.svg";
// @ts-ignore
import buildingIcon from "../../../../../assets/icons/CDA/building_white.svg";
// @ts-ignore
import userIcon from "../../../../../assets/icons/CDA/user_white.svg";

interface Props {
  dataHeader: any;
}

const MainHeader = ({ dataHeader }: Props) => {
  const [showFontSettings, setShowFontSettings] = useState<boolean>(false);
  const [isDark, changeDarkMode] = useChangeTheme();
  const { selectedTab } = useContext(GlobalContext);

  const logoCDA = {
    ...(isDark
      ? { src: dataHeader.nodes[0].image[1].file.url }
      : { src: dataHeader.nodes[0].image[0].file.url }),
    titleAtt: dataHeader.nodes[0].image[0].title,
  };

  const handleTabSelection = (type: Tabs) => {
    selectedTab.set(type);
    navigate("/");
  };

  return (
    <div className="m-header">
      <div className="m-header__main-header">
        <Link to="/" onClick={() => document.body.classList.remove("noscroll")}>
          <img
            className="a-logo-cda"
            src={logoCDA.src}
            alt="Logo y enlace a la página principal del Centro de ayuda Comfama"
            title={logoCDA.titleAtt}
          />
        </Link>
        <BurgerMenu />

        <div className="selector-type">
          <button
            className={`${selectedTab.get === "personas" ? "active" : ""} ${
              isDark ? "dark" : ""
            }`}
            onClick={() => handleTabSelection("personas")}
          >
            <img src={userIcon} alt="selector personas" />
            Personas
          </button>
          <button
            className={`${selectedTab.get === "empresas" ? "active" : ""} ${
              isDark ? "dark" : ""
            }`}
            onClick={() => handleTabSelection("empresas")}
          >
            <img src={buildingIcon} alt="selector empresas" />
            Empresas
          </button>
        </div>

        <div className="accesibility__buttons">
          <button onClick={changeDarkMode}>
            <img
              src={isDark ? moonBlack : moonWhite}
              alt="Botón para cambiar el tema de la página"
            />
          </button>

          <button onClick={() => setShowFontSettings(!showFontSettings)}>
            <img
              src={isDark ? accesibilityWhiteIcon : accesibilityIcon}
              alt="Botón para aumentar o disminuir el tamaño de la letra"
            />
          </button>

          {showFontSettings && <FontSizeSettings />}

          <Link
            to="https://www.comfama.com/"
            target="_blank"
            aria-label="Enlace a página oficial Comfama"
            className="gtmRedireccioncomfama.com header__link"
          >
            Comfama.com
          </Link>
        </div>
      </div>

      <div className="m-header__bottombar">
        <SearchBarHeader />
      </div>

      {showFontSettings && (
        <div
          className="font-size-settings-bg"
          onClick={() => setShowFontSettings(false)}
        />
      )}
    </div>
  );
};

export default MainHeader;
